import React, { useEffect, useLayoutEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default function ClusteredAmChart(props) {
  const { targetData } = props;
  const [viewData, setViewData] = useState([]);
  useEffect(() => {
    if (targetData) {
      const data = [
        {
          category: "HBB",
          sales: parseInt(targetData?.HBB?.sales_count),
          target: parseInt(targetData?.HBB?.target),
          achievement: parseInt(targetData?.HBB?.achieved_percentage),
        },
        {
          category: "Hayyak",
          sales: parseInt(targetData?.Hayyak?.sales_count),
          target: parseInt(targetData?.Hayyak?.target),
          achievement: parseInt(targetData?.Hayyak?.achieved_percentage),
        },
        {
          category: "Baqati",
          sales: parseInt(targetData?.Baqati?.sales_count),
          target: parseInt(targetData?.Baqati?.target),
          achievement: parseInt(targetData?.Baqati?.achieved_percentage),
        },
        {
          category: "Upgrade",
          sales: parseInt(targetData?.Upgrade?.sales_count),
          target: parseInt(targetData?.Upgrade?.target),
          achievement: parseInt(targetData?.Upgrade?.achieved_percentage),
        },
      ];
      setViewData(data);
    }
  }, [targetData]);

  useLayoutEffect(() => {
    const chart = am4core.create("chartdiv5", am4charts.XYChart);
    chart.scrollbarX = new am4core.Scrollbar();

    chart.data = viewData

    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 60;
    categoryAxis.tooltip.disabled = true;

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minWidth = 50;
    valueAxis.min = 0;
    valueAxis.cursorTooltipEnabled = false;

    let paretoValueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    paretoValueAxis.renderer.opposite = true;
    paretoValueAxis.min = 0;
    // paretoValueAxis.max = 100;
    paretoValueAxis.strictMinMax = true;
    paretoValueAxis.renderer.grid.template.disabled = true;
    paretoValueAxis.numberFormatter = new am4core.NumberFormatter();
    paretoValueAxis.numberFormatter.numberFormat = "#'%'";
    paretoValueAxis.cursorTooltipEnabled = false;

    let paretoSeries = chart.series.push(new am4charts.LineSeries());
    paretoSeries.dataFields.valueY = "achievement";
    paretoSeries.dataFields.categoryX = "category";
    paretoSeries.yAxis = paretoValueAxis;
    paretoSeries.tooltipText = "Achievement: {valueY.formatNumber('#.0')}%[/]";
    paretoSeries.bullets.push(new am4charts.CircleBullet());
    paretoSeries.strokeWidth = 2;
    paretoSeries.stroke = new am4core.InterfaceColorSet().getFor(
      "alternativeBackground"
    );
    paretoSeries.strokeOpacity = 0.5;

    // Cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "panX";

    chart.colors.step = 2;

    chart.legend = new am4charts.Legend();
    chart.legend.position = "top";
    chart.legend.paddingBottom = 20;
    chart.legend.labels.template.maxWidth = 95;

    function createSeries(value, name) {
      const series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = value;
      series.dataFields.categoryX = "category";
      series.name = name;

      const bullet = series.bullets.push(new am4charts.LabelBullet());
      bullet.interactionsEnabled = false;
      bullet.dy = 30;
      bullet.label.text = "{valueY}";
      bullet.label.fill = am4core.color("#ffffff");

      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.columns.template.column.fillOpacity = 0.8;
      series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      series.columns.template.strokeWidth = 0;

      // on hover, make corner radiuses bigger
      let hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      return series;
    }

    // Modify chart's colors
    chart.colors.list = [
      am4core.color("#0063a4"),
      am4core.color("#f89d21"),
      am4core.color("#f89d21").lighten(0.3),
      am4core.color("#0063a4").lighten(0.1),
      am4core.color("gray"),
      am4core.color("#f89d21").lighten(0.2),
    ];

    createSeries("sales", "Sales");
    createSeries("target", "Target");

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return <div id="chartdiv5" style={{ width: "100%", height: "500px" }} />;
}
